export const treemapVariants = {
  default: {
    code: 'default',
    displayName: 'Default',
    description: 'Standard treemap with labeled rectangles and hierarchical drill-down.',
    overrides: {
      props: {},
      className: null,
      styles: {}
    }
  },
  flat: {
    code: 'flat',
    displayName: 'Flat',
    description: 'Treemap with configurable borders and gap. Creates a smoother, mosaic-like appearance.',
    parameters: [
      {
        key: 'borderWidth',
        type: 'select',
        label: 'Border Width',
        default: 0,
        options: [
          { value: 0, label: 'None' },
          { value: 1, label: 'Thin' },
          { value: 2, label: 'Medium' }
        ]
      },
      {
        key: 'gapWidth',
        type: 'select',
        label: 'Gap Width',
        default: 1,
        options: [
          { value: 0, label: 'None' },
          { value: 1, label: 'Thin' },
          { value: 2, label: 'Medium' },
          { value: 4, label: 'Wide' }
        ]
      }
    ],
    resolve: (params) => ({
      props: {},
      className: null,
      tableClassName: null,
      styles: {
        borderWidth: params.borderWidth,
        gapWidth: params.gapWidth
      }
    })
  }
}
